import React from 'react';
import classnames from 'classnames';
import HoverOnly from '../../../Helper/OverlayHelpers/HoverOnly';
import DeviationThumbOverlayDefault from '../DeviationThumbOverlayDefault';
import DeviationThumbMiddleContent from '../DeviationThumbMiddleContent';
import ThumbOverlayBackground from '../ThumbOverlayBackground';
import ThumbOverlayHover from '../ThumbOverlayHover';
import s from './Overlay.scss';
var Overlay = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, className = _a.className, hasCommentedOn = _a.hasCommentedOn, children = _a.children, isFaved = _a.isFaved, ariaHidden = _a["aria-hidden"], extraActions = _a.extraActions;
    return (React.createElement("div", { className: classnames(s['root'], className), style: { width: width, height: height }, "aria-hidden": ariaHidden },
        React.createElement(ThumbOverlayBackground, { deviation: deviation, className: s['underlay'], showDefaultHover: true }),
        React.createElement(HoverOnly, { reverseHidden: true, className: s['cover'] },
            React.createElement(DeviationThumbOverlayDefault, { deviation: deviation, width: width, height: height, isFaved: isFaved, hasCommentedOn: hasCommentedOn })),
        React.createElement(ThumbOverlayHover, { className: s['cover'], deviation: deviation, width: width, height: height, extraActions: extraActions }),
        React.createElement(DeviationThumbMiddleContent, { deviation: deviation, thumbWidth: width, thumbHeight: height, className: s['middle'] }, children)));
};
Overlay.displayName = 'Overlay';
export default Overlay;
//# sourceMappingURL=Overlay.js.map